/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';
import prestashop from 'prestashop';

function setUpCheckout() {

  $('.js-terms a').on('click', (event) => {
    event.preventDefault();
    var url = $(event.target).attr('href');
    if (url) {
      // TODO: Handle request if no pretty URL
      url += `?content_only=1`;
      $.get(url, (content) => {
        $('#modal').find('.js-modal-content').html($(content).find('.page-content--cms').contents());
      }).fail((resp) => {
        prestashop.emit('handleError', {eventType: 'clickTerms', resp: resp});
      });
    }

    $('#modal').modal('show');
  });

  $('.js-gift-checkbox').on('click', (event) => {
    $('#gift').collapse('toggle');
  });
}

$(document).ready(() => {
  if ($('body#checkout').length === 1) {
    setUpCheckout();
  }

  prestashop.on('updatedDeliveryForm', (params) => {
    if (typeof params.deliveryOption === 'undefined' || 0 === params.deliveryOption.length) {
        return;
    }
    // Hide all carrier extra content ...
    $(".carrier-extra-content").hide();
    // and show the one related to the selected carrier
    params.deliveryOption.next(".carrier-extra-content").slideDown();
  });
    prestashop.on('changedCheckoutStep', (params) => {

        if(typeof params.event.currentTarget !== 'undefined'){
            $('.collapse',params.event.currentTarget).not('.show').not('.collapse .collapse').collapse('show');
        }
    });

});

$(document).on('change','.js-input-delivery:checked', (event) => {
    $('.js-label-delivery.selected').removeClass('selected');
    console.log('toto');
    $('#js-'+$(this).attr('id')).addClass('selected');
});

/***AJOUT 123***/
$(document).on('change','.delivery-option  .custom-control-input:checked', (event) => {
    $('.delivery-option.delivery-option-checked').removeClass('delivery-option-checked');
    $(".custom-control-input:checked").parents(".delivery-option").addClass('delivery-option-checked');
});

/***END AJOUT 123***/

$(document).on('click','.js-checkout-step-header', (event) => {
    let stepIdentifier = $(event.currentTarget).data('identifier');
    $('#'+stepIdentifier).addClass('-current');
    $('#content-'+stepIdentifier).collapse('show').scrollTop();
});



/***AJOUT 123 pour module lyra pour personnaliser les textes de boutons paiement***/
if ($("#js-checkout-process").length > 0 ){
	if (typeof KR !== 'undefined') {
	KR.onFormReady(function () {
	  KR.setFormConfig({
	      smartForm: {
	          paymentMethods: {
	              "PAYCONIQ": {
	                  label: "Payconiq"
	              },
	              "ALMA_3X": {
	                  label: "3x sans frais avec Alma"
	              },
                  "ALMA_4X": {
                      label: "4x sans frais avec Alma"
                  },
	              "IP_WIRE": {
	                  label: "Virement immédiat"
	              }
	          }
	      },
	  });
	   KR.onError(function(event) {
	      var code = event.errorCode;
	      if (code == "CLIENT_312") {
	          $('html, body').animate({
	              scrollTop: $('#conditions-to-approve').offset().top
	            }, 'slow');
	      }
	  })
	});
}
}

